/**
 * Shared styling for the SEO block and the related-pages section that follows it, so the two
 * search arms and the two sections keep one rhythm (WHO-5534, review round 2).
 *
 * The block is supporting content under the results and should read like the top of the
 * footer: h4-size headings (Filson Pro 18/28) for every section whatever its outline level,
 * 16px bold questions in grey-800, prose capped at a readable width, half the spacing the first
 * round shipped.
 */

/** Section headings inside the block: block title, FAQ, guides, related pages. */
export const PLP_SEO_SECTION_HEADING_SIZE = "h4" as const;

/** Question rows and card titles. */
export const PLP_SEO_LEAF_HEADING_SIZE = "h5" as const;

/** Max width for prose (intro, subheading, questions). Chips and cards stay full width. */
export const PLP_SEO_TEXT_WIDTH_CLASS = "max-w-3xl";

/** One section: top rule, halved vertical padding, halved gap between parts. */
export const PLP_SEO_SECTION_CLASS =
  "flex flex-col gap-4 border-t border-grey-300 py-4 md:gap-5 md:py-6";
